module.exports = __webpack_public_path__ + "static/media/chart.09cb4551.svg";